import React, { Component } from 'react';
import { connect } from 'react-redux';
import CheckboxGroup from 'react-checkbox-group'
import { updateFilters } from '../search/actions';
import { HostRules } from '../dashboard/listing/constants';

const mapStateToProps = (state) => ({
  search: state.Search,
});

class HostRulesSelect extends Component {
  constructor(props) {
    super(props);

    this.onSelectionChange = this.onSelectionChange.bind(this);
  }

  onSelectionChange = (selections) => {
    const { dispatch } = this.props;
    const { filters } = this.props.search;

    const newFilters = [...filters];

    newFilters.petsAllowed = selections.includes(HostRules.PETS_ALLOWED);
    newFilters.smokingAllowed = selections.includes(HostRules.SMOKING_ALLOWED);

    dispatch(updateFilters(newFilters));
  };

  render() {
    const { rules } = this.props;
    const { appliedRules } = this.props;

    return (
      <div>
        <CheckboxGroup
          label="Host Rules"
          value={appliedRules}
          onChange={this.onSelectionChange}
        >
          {(Checkbox) => (
            <div className="host-check-lab">
              {rules.map((rule) => {
                return (
                  <label>
                    <Checkbox value={rule} /> {rule}
                  </label>
                );
              })}
            </div>
          )}
        </CheckboxGroup>
      </div>
    );
  }
}

export default connect(mapStateToProps)(HostRulesSelect);
